<div class="form-blocks" *ngIf="uniqueIdentifier">
    <div class="form-block amb-15">
        <div class="header">
            <span>{{ translationManager.getTranslation(uniqueIdentifier + '-Title') }}</span>
        </div>
        <div class="content">
            <div class="form-element amb-5" [ngClass]="{ 'error': form.elements[language.culture].error.required }" *ngFor="let language of translationManager.languages?.languages">
                <label>{{ translationManager.getTranslation(uniqueIdentifier) + ' - ' + language.name }}</label>
                <div class="content">
                    <input maxlength="50" type="text" name="name" [(ngModel)]="form.elements[language.culture].value">
                </div>
                <div class="errors">
                    <span *ngIf="form.elements[language.culture].error.required"><i
                            class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>
                </div>
            </div>
        </div>
    </div>
</div>